document.addEventListener("DOMContentLoaded", function () {
  // ======= Боковая панель блока 3 =======
  const openButtons = document.querySelectorAll(".fit-button--mobile, .fit-button--desktop");
  const closeButton = document.getElementById("close-panel-btn");
  const panel = document.getElementById("side-panel");
  const overlay = document.getElementById("panel-overlay");
  const body = document.body;

  if (openButtons.length && closeButton && panel && overlay) {
    openButtons.forEach(button => {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        panel.classList.add("open");
        overlay.classList.add("active");
        body.classList.add("no-scroll");
      });
    });

    function closePanel() {
      panel.classList.remove("open");
      overlay.classList.remove("active");
      body.classList.remove("no-scroll");
    }

    closeButton.addEventListener("click", closePanel);
    overlay.addEventListener("click", closePanel);
  }

  // ======= Слайдер блока 7 =======
  const simpleSlides = document.querySelectorAll(".simple-slider .slide");
  const nextBtn = document.querySelector(".simple-slider .next-btn");
  const prevBtn = document.querySelector(".simple-slider .prev-btn");

  if (simpleSlides.length && nextBtn && prevBtn) {
    let currentSlide = 0;

    function showSimpleSlide(index) {
      simpleSlides.forEach((slide, i) => {
        slide.classList.toggle("active", i === index);
      });
    }

    nextBtn.addEventListener("click", function () {
      currentSlide = (currentSlide + 1) % simpleSlides.length;
      showSimpleSlide(currentSlide);
    });

    prevBtn.addEventListener("click", function () {
      currentSlide = (currentSlide - 1 + simpleSlides.length) % simpleSlides.length;
      showSimpleSlide(currentSlide);
    });
  }

  // ======= Открывание FAQ =======
  const faqItems = document.querySelectorAll(".faq-item");

  if (faqItems.length) {
    faqItems.forEach(item => {
      const button = item.querySelector(".faq-question");
      const answer = item.querySelector(".faq-answer");
      const icon = button?.querySelector("img");

      if (!button || !answer || !icon) return;

      button.addEventListener("click", () => {
        const isOpen = button.getAttribute("aria-expanded") === "true";

        faqItems.forEach(el => {
          const ans = el.querySelector(".faq-answer");
          const btn = el.querySelector(".faq-question");
          const img = btn?.querySelector("img");

          if (ans && btn && img) {
            ans.style.maxHeight = null;
            btn.setAttribute("aria-expanded", "false");
            img.src = "https://cdn.shopify.com/s/files/1/0782/0332/2711/files/AnyConv.com_eae2cba7-29d4-4777-9e84-0b49f4d8cff8.webp?v=1750017380";
          }
        });

        if (!isOpen) {
          answer.style.maxHeight = answer.scrollHeight + "px";
          button.setAttribute("aria-expanded", "true");
          icon.src = "https://cdn.shopify.com/s/files/1/0782/0332/2711/files/AnyConv.com_0e57859c-edbd-4b9d-a561-65033dda0faa.webp?v=1750017380";
        }
      });
    });
  }

  // ======= Sticky CTA =======
  const stickyBtn = document.getElementById("stickyCta");
  const trigger = document.querySelector(".trigger-cta");
  const anchor = document.querySelector(".cta-anchor");

  if (stickyBtn && trigger && anchor) {
    const showObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyBtn.classList.add("visible");
        }
      });
    });

    const hideObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyBtn.classList.remove("visible");
        }
      });
    });

    showObserver.observe(trigger);
    hideObserver.observe(anchor);
  }

  
  // ======= MAIN-3 Slider =======
  const reviewCards = document.querySelectorAll(".review-card");
const dots = document.querySelectorAll(".slider-dots .dot");
const track = document.querySelector(".slider-track");

if (reviewCards.length && dots.length && track) {
  let currentIndex = 0;
  const totalSlides = reviewCards.length;

  function updateSlider(index) {
    const offset = -index * 100;
    track.style.transform = `translateX(${offset}%)`;

    dots.forEach(dot => dot.classList.remove("active"));
    if (dots[index]) dots[index].classList.add("active");
  }

  updateSlider(currentIndex);

  dots.forEach(dot => {
    dot.addEventListener("click", () => {
      currentIndex = parseInt(dot.dataset.index);
      updateSlider(currentIndex);
    });
  });

  track.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  track.addEventListener("touchend", (e) => {
    const endX = e.changedTouches[0].clientX;
    const delta = endX - startX;

    if (delta > 50) {
      currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      updateSlider(currentIndex);
    } else if (delta < -50) {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateSlider(currentIndex);
    }
  });
}


  // ======= ORDER-REGISTRATION color and size =======
  const sizeOptions = document.querySelectorAll(".size-option");
  const colorOptions = document.querySelectorAll(".color-option");

  const indicatorDefault = "https://cdn.shopify.com/s/files/1/0782/0332/2711/files/7b9941591174dd80de5b3a59a3da67cb.webp?v=1750772401";
  const indicatorSelected = "https://cdn.shopify.com/s/files/1/0782/0332/2711/files/74e3ed4b7ae292314498d5842768bc04.webp?v=1750772401";

  let selectedSize = null;
  let selectedColor = null;

  function clearActive(options) {
    options.forEach(option => {
      option.classList.remove("active");
      const img = option.querySelector("img");
      if (img) img.src = indicatorDefault;
    });
  }

  function setActive(option, group) {
    const options = group === "size" ? sizeOptions : colorOptions;
    clearActive(options);
    option.classList.add("active");
    const img = option.querySelector("img");
    if (img) img.src = indicatorSelected;
  }

  sizeOptions.forEach(option => {
    option.addEventListener("click", () => {
      selectedSize = option.getAttribute("data-size");
      setActive(option, "size");
    });
  });

  colorOptions.forEach(option => {
    option.addEventListener("click", () => {
      selectedColor = option.getAttribute("data-color");
      setActive(option, "color");
    });
  });

  const variantMap = {
    "S:Snowy White": "50725918409047",
    "XS:Snowy White": "50725918441815",
    "XS Widened:Snowy White": "50725918474583",
    "XXS:Snowy White": "50725918507351",
    "S:Playful Pink": "50725918540119",
    "XS:Playful Pink": "50725918572887",
    "XS Widened:Playful Pink": "50725918605655",
    "XXS:Playful Pink": "50725918638423"
  };

  const checkoutButton = document.querySelector(".checkout-button");
  if (checkoutButton) {
    checkoutButton.addEventListener("click", () => {
      if (!selectedSize || !selectedColor) {
        alert("Please select both a size and a color.");
        return;
      }

      const variantKey = `${selectedSize}:${selectedColor}`;
      const variantId = variantMap[variantKey];

      if (!variantId) {
        alert("Invalid combination. Please try again.");
        return;
      }

      window.location.href = `/cart/${variantId}:1`;
    });
  }

  // ======= ORDER-REGISTRATION measuring guide =======
  const guideBtn = document.getElementById("seeGuideTrigger");
  const modal = document.getElementById("measuringGuideModal");
  const closeBtn = document.getElementById("closeGuide");

  if (guideBtn && modal && closeBtn) {
    guideBtn.addEventListener("click", () => {
      modal.classList.add("active");
      document.body.classList.add("body-no-scroll");
    });

    closeBtn.addEventListener("click", () => {
      modal.classList.remove("active");
      document.body.classList.remove("body-no-scroll");
    });
  }

  // ======= Back Button =======
  const backButton = document.querySelector(".back-button");
  if (backButton) {
    backButton.addEventListener("click", function () {
      history.back();
    });
  }
});




// ======= Анимация загрузка на странице отзывов =======

  document.addEventListener("DOMContentLoaded", function () {
    const button = document.getElementById("loadMoreBtn");

    button.addEventListener("click", function (e) {
      e.preventDefault();
      button.classList.add("loading");
      setTimeout(() => {
        button.classList.remove("loading");
      }, 20000); // эффект исчезнет через 3 секунды
    });
  });






